import React from 'react'
import styled from 'styled-components'

export interface AuthFooterProps {
  version?: string
  brand?: string
  year?: number
  className?: string
}

export const AuthFooter: React.FC<AuthFooterProps> = ({
  version = __APP_VERSION__,
  brand = 'AGROLINE',
  year = new Date().getFullYear(),
  className,
}) => (
  <Foot className={className}>
    <span>© {year} {brand}</span>
    {version && <span>v{version}</span>}
  </Foot>
)
AuthFooter.displayName = 'AuthFooter'

const Foot = styled.div`
  margin-top: 1.125rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.colors.ink3};
`

export default AuthFooter
